import { UserHeaderMinimised } from 'components/headers/user-header/UserHeaderMinimised';
import { Fragment, useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports
import { MdOutlineKeyboardDoubleArrowRight } from 'react-icons/md';
import { IUserProfile } from 'types';

interface IUplineListProps {
  readonly upline: ReadonlyArray<IUserProfile>;
  readonly onExploreUserDownline: (userId: string) => void;
}

export function UplineList({
  upline,
  onExploreUserDownline
}: IUplineListProps) {
  const handleUserClick = useCallback(
    (userId: string, event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      onExploreUserDownline(userId);
    },
    [onExploreUserDownline]
  );

  return (
    <ol className="flex lg:flex-wrap items-baseline gap-2 overflow-x-auto">
      {upline.map(user => (
        <Fragment key={user.userId}>
          <li>
            <button
              className="max-w-[150px] bg-white rounded shadow hover:bg-gray-100 transition"
              onClick={event => handleUserClick(user.userId, event)}
              aria-label={`Explore downline of team partner ${user.name}`}
            >
              <UserHeaderMinimised user={user} />
            </button>
          </li>

          <li className="self-center text-primary last:hidden">
            <MdOutlineKeyboardDoubleArrowRight />
          </li>
        </Fragment>
      ))}
    </ol>
  );
}
